import moment from "moment";
import { STATUSES_ICONS } from "../constants/order.constants";
import { truncate } from "lodash";

export const curatedEvents = (order) => {
  if (!order.events) return [];

  const statuses = {
    awaiting_pickup: "Esperando recolección",
    delivered: "Entregado",
    dispatched: "Despachado",
    in_post_office: "En sucursal",
    not_delivered: "No entregado",
    packing_slip: "Preparandose",
    ready_to_pick: "Listo para preparar",
    ready_to_ship: "Listo para despachar",
    rescheduling_visit: "Reprogramando visita a domicilio",
    shipped: "Recibido por el correo",
    visit_failed: "Visita a domicilio fallida",
    visit_scheduled: "Visita a domicilio programada",
    visit_shipping: "Visita a domicilio en curso",
    visit_without_news: "Visita a domicilio sin novedades",
  };

  return order.events.map((e) => ({
    status: statuses[e.status],
    code: e.status,
    timestamp: moment(e.changed_at),
  }));
};

export const statusIcon = (order) => {
  return STATUSES_ICONS[getCookedStatus(order)];
};

export const getCookedStatus = (order) => {
  if (!order) return null;

  if (
    (order.status === "new" || order.status === "on_hold") &&
    order.goods_in_item
  ) {
    return "pickup_requested";
  }

  return order.status;
};

export const getOrderItems = (order) => {
  return order.cookedItems.map((item) => ({
    id: `${item.id}-${order.id}`,
    image: item.thumbnail_url,
    label: `${truncate(item.title, { length: 80 })}${
      item.quantity > 1 ? `(x${item.quantity})` : ""
    }`,
  }));
};
